export default __webpack_public_path__ + "static/media/mergeAccountsCardPlaceholder.f6775821.svg";